export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: '运单编号',
    field: 'waybillNo',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: '始发地',
    field: 'origin',
    headerAlign: 'center',
    align: 'left',
    minWidth: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: '目的地',
    field: 'dest',
    headerAlign: 'center',
    align: 'left',
    minWidth: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
